import { FuncCustomVariable, FuncResponse, FuncResponseType, } from "../../storyV2/function/FunctionBase";
import { Meta } from "../../cutil/Meta";
import { ErrorUtil } from "../../api/ErrorUtil";
import { StoryUtil } from "../../storyV2/domain/StoryUtil";
import { ArrayUtil } from "../../util/ArrayUtil";
import isBlank from "@sedan-utils/is-blank";
import { GenUtil } from "../../cutil/GenUtil";
export class FunctionUtil {
    static async runAll(input, functions, variableList, identityInfo, requestParams) {
        return FunctionUtil.runFunc(0, new FuncResponse(FuncResponseType.TEXT, input), functions, variableList, identityInfo, requestParams);
    }
    static async findFuncAndRun(input, actionData, funcRegistry, variableList, identityInfo, checkStop, sourceNode, requestParams) {
        let functions = await funcRegistry.getByEdge(actionData, sourceNode);
        if (checkStop()) {
            const errorStr = ErrorUtil.defaultErrorMsg;
            throw new Meta("User cancel error", errorStr, "");
        }
        return await FunctionUtil.runAll(input, functions, variableList, identityInfo, requestParams);
    }
    /// todo：目前在串行调用过程中，默认每次执行返回的都是string，并把这个值作为下一次api的输入，可能需要优化，因为执行的返回可能stream流或者数组，分别需要有不同的处理
    static async runFunc(runIndex, source, functions, variableList, identityInfo, requestParams) {
        if (runIndex > functions.length - 1) {
            return Promise.resolve(source);
        }
        switch (source.type) {
            case FuncResponseType.STREAM_TEXT:
                return FunctionUtil.handleRunFuncStreamResult(runIndex, source, functions, variableList, identityInfo, requestParams);
            default:
                const func = functions[runIndex];
                const input = source.data;
                const res = await func.run(input, identityInfo, variableList, undefined, undefined, undefined, requestParams);
                return FunctionUtil.runFunc(runIndex + 1, res, functions, variableList, identityInfo, requestParams);
        }
    }
    static async handleRunFuncStreamResult(runIndex, source, functions, variableList, identityInfo, requestParams) {
        const streamResponse = source.data;
        const allTextPro = new Promise(executor => {
            streamResponse.onReceived(result => {
                executor(result.value);
            });
        });
        const func = functions[runIndex];
        const input = await allTextPro;
        const res1 = await func.run(input, identityInfo, variableList);
        return FunctionUtil.runFunc(runIndex + 1, res1, functions, variableList, identityInfo, requestParams);
    }
    static createFuncVariables(story, currentEdge) {
        const defaultNodeLabelName = "Input";
        const hasRealInputName = StoryUtil.findEdgeSoures(story, currentEdge).filter(node => {
            const label = node.options.inputTitle || node.options.generatedLabel;
            return label === defaultNodeLabelName;
        }).length !== 0;
        const variablesFromSourceNode = StoryUtil.findEdgeSoures(story, currentEdge)
            .map(node => {
            const inputTitle = node.options.inputTitle;
            const generatedLabel = node.options.generatedLabel;
            /// inputTitle有值，prompt里key是inputTitle
            if (!isBlank(inputTitle) && inputTitle !== "") {
                return [new FuncCustomVariable(inputTitle, node.content)];
            }
            if (!isBlank(generatedLabel) && generatedLabel !== "") {
                /// 中间版本：inputTitle无值generatedLabel有值时，prompt里key是"Input"
                /// 新版本：inputTitle无值generatedLabel有值时，prompt里key是generatedLabel
                /// 所以这是兼容写法，都传，两个版本都工作
                if (hasRealInputName) {
                    return [new FuncCustomVariable(generatedLabel, node.content)];
                }
                return [
                    new FuncCustomVariable(generatedLabel, node.content),
                    new FuncCustomVariable(defaultNodeLabelName, node.content),
                ];
            }
            /// inputTitle无值generatedLabel也无值时，prompt里是"Input"
            return [new FuncCustomVariable(defaultNodeLabelName, node.content)];
        })
            .flat();
        const variablesFromProject = story.variableList.map(oriModel => {
            const realNode = story.findNodesById(oriModel.nodeId);
            if (realNode == undefined) {
                return new FuncCustomVariable(oriModel.name, oriModel.defaultValue);
            }
            else {
                return new FuncCustomVariable(oriModel.name, realNode.content);
            }
        });
        const returnArr = variablesFromSourceNode;
        for (const v of variablesFromProject) {
            if (!ArrayUtil.contains(returnArr, v, e => e.name)) {
                returnArr.push(v);
            }
        }
        return returnArr;
    }
    static createAbortUuid(identityInfo) {
        let apiUuid;
        if (identityInfo) {
            apiUuid = identityInfo.projectId + identityInfo.edgeId + GenUtil.randomString();
        }
        return apiUuid;
    }
    /**
     * 如果是一个已经是一个json 字符串那么直接返回，如果不是，那么就stringfy
     * 传入的text: 是一个字符串，可以是json字符串，也可以是普通字符串。
     * @param text
     */
    static alwaysStringfy(text) {
        let inputStr = text;
        let str = text.trimStart();
        // 普通字符串非json字符串，就是一个文本
        if (!str.startsWith("{") && !str.startsWith("[")) {
            try {
                let inputJsonStr = JSON.parse(text);
                if (inputJsonStr) {
                    // 说明是已经转义过来的
                    return text;
                }
            }
            catch (error) {
                // 还没有转义过，那么转移后再返回
                return JSON.stringify(text);
            }
            return undefined;
        }
        // 对象类型的字符串
        try {
            const json = JSON.parse(text);
            if (json) {
                return text;
            }
        }
        catch (error) {
            return text;
        }
    }
    static bodyParamReplace(input, bodyParam) {
        const inputStr = this.alwaysStringfy(input) ?? input;
        const bodyParamResult = bodyParam?.replace(/\"\$\{currentSourceNodeValue\}\"/g, inputStr);
        return bodyParamResult;
    }
    static createFuncRunIdentityInfo(story, edge) {
        return {
            projectId: story.projectId,
            edgeId: edge.options.id,
            templateId: story.templateId,
        };
    }
}
